module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABsSURBVHgB7ZS7DYAwDETvmIEBWJERmBQ6GpBYAA7cRSJ8EkQB8pPS2PI96YoAzlN6oBrJdiAVPpvZ7uqesaEFIINS2uUV+Do8WqTWFKvHeL0iF7jABX8XTLjJ9gl1SBUsUn12GIRPs9TAyWUFiQMgCRNmOu4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete_red.png
// module id = wpmo
// module chunks = 1